import PcDatabasePanel from "~/components/category/[id]/database/database-panel/PcDatabasePanel";
import SpDatabasePanel from "~/components/category/[id]/database/database-panel/SpDatabasePanel";
import useIsSpMode from "~/lib/client/hooks/useIsSpMode";

type Database = {
  id: number;
  title: string;
  createdAt: string;
  categories: {
    id: number;
    name: string;
  }[];
  postSize: number;
};

type Props = {
  database: Database;
};

export type { Props };

export default function DatabasePanel(props: Props) {
  const isSpMode = useIsSpMode();
  return isSpMode ? (
    <SpDatabasePanel {...props} />
  ) : (
    <PcDatabasePanel {...props} />
  );
}
